import React, { useState, useEffect } from "react";
import routes from '../api/index';
import Userpage from './userpage';
import Navbar from './navbar'
import '../styles/login.css'

const Login = (props) => {
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")

    function handleLogin() {        
        routes.login({
            username: username,
            password: password
        })
            .then(response => response.data.message)
            .then((prev) => {
                if (prev === "Login Successful!") {
                    props.setToken(username)
                    console.log("Login Successful!")
                } else if (prev === "Incorrect Password") {
                    alert("Incorrect username or Password")
                } else if (prev === "User not Found!") {
                    alert("Incorrect username or Password")
                }
            }
        )
        //console.log(loginInfo)
    }

    return <div>
            <Navbar loggedIn={false}/>
            <div id="login-screen" className="h-screen grid grid-rows-6 justify-center">
                <div id="introduction" className="text-2xl grid place-items-center text-center row-start-2">
                    <h1 id="login-title">Bist</h1>
                    <p className="login-text h-full">
                        Read. Keep Track. Organize.
                    </p>
                </div>
                <div id="login-wrapper" className="mt-16 grid place-items-center row-start-3">
                    <div className="h-full w-3/5 grid place-items-center justify-center">
                        <div id="login-form" className="login-text">
                            <label>Username</label><br/>
                            <input className="mb-3 border-0 border-b-2 border-red-200 outline-none focus:border-red-300 focus:bg-gray-200 transition-all pl-2" type="text" onChange ={e => setUsername(e.target.value)} /> <br></br>
                            <label>Password</label><br/>
                            <input className="mb-3 border-0 border-b-2 border-red-200 outline-none focus:border-red-300 focus:bg-gray-200 transition-all pl-2" type="password" onChange = {e => setPassword(e.target.value)} /><br/>
                            <button className="outline-none focus:outline-none border-0 border-b-2 border-red-200 p-1 hover:bg-red-300 hover:border-transparent transition-all" onClick={handleLogin}> Login </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
}

export default Login